import InboxView from './InboxView';
import ChartsView from './ChartsView';
import SearchView from './SearchView';
import TaskView from './TaskView';
import ComponentsView from './ComponentsView';
import ElementsView from './ElementsView';
import CardsView from './CardsView';
import FormsView from './FormsView';
import TablesView from './TablesView';
import Timeline from './Timeline';
import TimelineGallery from './TimelineGallery';
import Typography from './Typography';
import Illustrations from './Illustrations';
import Icons from './Icons';
import Pricing from './Pricing';
import Faq from './Faq';
import Error500 from './Error500';
import NotFound from './NotFound';

let Dashboards = {};
Dashboards['Dashboard'] = require('./dashboards/Dashboard').default;
Dashboards['Dashboard1'] = require('./dashboards/Dashboard1').default;
Dashboards['Dashboard2'] = require('./dashboards/Dashboard2').default;
Dashboards['Dashboard3'] = require('./dashboards/Dashboard3').default;
Dashboards['Dashboard4'] = require('./dashboards/Dashboard4').default;

export {
    Dashboards,
    InboxView,
    ChartsView,
    SearchView,
    TaskView,
    ComponentsView,
    ElementsView,
    CardsView,
    FormsView,
    TablesView,
    Timeline,
    TimelineGallery,
    Typography,
    Illustrations,
    Icons,
    Pricing,
    Faq,
    Error500,
    NotFound
};